import React, { useState } from 'react';
import { TextField, Button, Container, Box, Typography } from '@mui/material';
import AlertModal from '../modals/AlertModal';
import useAlert from '../../hooks/useAlert';
import useAuth from '../../hooks/useAuth';
import { useSearchParams } from 'react-router-dom';
import { REGISTER_ID_PARAM_NAME } from '../../config/constants';

interface RegisterProps {
  onSuccess: (name: string) => void; // what to do when successfully registered
}

export default function Register({ onSuccess }: RegisterProps) {
  const { register } = useAuth();

  const [searchParams] = useSearchParams();

  const [username, setUsername] = useState(searchParams.get(REGISTER_ID_PARAM_NAME) ?? '');
  const [nickname, setNickname] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const { alertOpen, alertMessage, showAlert, closeAlert } = useAlert();

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();

    if (username == null ||
      username.length < 3 ||
      password == null ||
      password.length < 3 ||
      confirmPassword !== password) {
      showAlert('Please check your username and password are 3 or more characters and your passwords match');
      return;
    }

    if (!nickname) {
      showAlert('Please enter a nickname');
      return;
    }

    setIsSubmitting(true);
    register(username, nickname, password).then(
      (response) => {
        if (response.status === 201) {
          onSuccess(username);
        } else {
          response.text().then((text) => showAlert(`Registration error: ${text}`));
        }
      }
    ).catch(
      (error) => {
        showAlert(`Unexpected registration error ${error}`);
      }
    ).finally(
      () => { setIsSubmitting(false); }
    );
  };

  return (
    <Container component="div" maxWidth="xs">
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        mt={0}
      >
        <form onSubmit={handleSubmit}>
          <Typography>
            You may only register if you have been assigned a personal login ID.
          </Typography>
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            id="username"
            label="Issued login ID"
            name="username"
            autoFocus
            value={username}
            onChange={(e) => setUsername(e.target.value)}
          />
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            id="nickname"
            label="Choose your screen name"
            name="nickname"
            autoFocus
            value={nickname}
            onChange={(e) => setNickname(e.target.value)}
          />
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            name="password"
            label="Choose a password"
            type="password"
            id="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            name="confirmPassword"
            label="Confirm password"
            type="password"
            id="confirmPassword"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
          />
          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
            disabled={isSubmitting}
          >
            Register
          </Button>
        </form>
      </Box>
      <AlertModal open={alertOpen} onClose={closeAlert} message={alertMessage} />
    </Container>
  );
}

